//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";
import * as moment from 'moment';

// custom pages
import Loyalty from "apis/loyalty/loyalty";
import Context from "context/context";
import { Styles } from "./styles";

// material-ui
import { Paper, TextField, Grid, Button, CssBaseline } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { useTranslation } from 'react-i18next';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { enUS, fr } from "date-fns/locale";
import DeleteIcon from "@material-ui/icons/Delete";
import ControlPointIcon from "@material-ui/icons/ControlPoint";

export default function CustomerLogin() {
  const { createLoyalty } = Loyalty();
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const classes = Styles();

  const toastCss = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  };

  const [requester, setRequester] = useState({
    requestType: "",
    shipto: "",
    memberId: "",
    bypass: false,
    loyaltyStartDate: new Date()
  });

  const [concurrentShipto, setConcurrentShipto] = useState([{
    shipto: '',
    signatureStartDate: new Date(),
    privilegecode: ''
  }])

  const [roles, setRoles] = useState([]);
  const [modalData, setModalData] = useState({});
  const [modal, setModal] = useState(false);
  const { t, i18n } = useTranslation();
  const [signatureStartDateErr, setSignatureStartDateErr] = useState({
    error: false,
    text: ''
  });
  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Enrollment"],
    });
  }, []);

  // create users api func
  async function handleCreateUsers() {
    try {
      let arg = {
        requestType: requester.requestType,
        bypass: requester.bypass,
        loyaltyStartDate: requester?.loyaltyStartDate
      };

      if (requester.requestType == 1) {
        arg = {
          ...arg,
          shipto: requester.shipto
        };
      }
      if (requester.requestType == 2) {
        arg = {
          ...arg,
          shipto: requester.shipto,
          memberId: requester.memberId,
        };
      }
      if (requester.requestType == 3) {
        arg = {
          ...arg,
          shipto: concurrentShipto
        }
      }

      let res = await createLoyalty(arg);
      if (res && res.type == "success" && res.process_type === 0) {
        history.push("/dashboard/user-confirmation", {
          data: res?.data,
          type: arg.requestType,
        });
        return;
      } else if (res && res.type == "success" && res.process_type === 1) {
        history.push("/dashboard/upload-success", { type: res?.message });
        return;
      }
      toast.error(
        res && res.message ? i18n.language == 'fr' ? res.french_message : res.message : t("Something Went Wrong"),
        { toastId: "create-loyalty-error", ...classes.toastCss }
      );
    } catch (e) {
      console.log({ e });
    }
  }

  console.log(concurrentShipto.privilegecode)

  const locale = i18n.language == 'fr' ? fr : enUS;
  const org = state?.userInfo?.loyalty_organization_name;
  let typeArr = org == 'Henry Schein Dental' ?
    [
      { name: "Rewards Enrollment", type: 1 }
      // { name: "Rewards & Signature Enrollment", type: 3 }
    ] :
    [{ name: "Rewards Enrollment", type: 1 }];

  return (
    <React.Fragment>
      <div className={classes.mainDiv}>
        <CssBaseline />
        <Paper className={classes.root}>
          <Grid container alignItems="flex-start" spacing={2}>
            <React.Fragment>
              <Grid container>
                <Grid item xs={12}>
                  <div className={classes.createLA}> {t('Create Loyalty Account')}</div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  select
                  fullWidth
                  label={t('Type')}
                  className={classes.roleInput}
                  value={requester.requestType}
                  onChange={(e) => {
                    setRequester({
                      ...requester,
                      requestType: e.target.value,
                      memberId: "",
                      shipto: "",
                    });
                  }}
                >
                  {typeArr.map((r, i) => (
                    <MenuItem value={r.type} key={i}>
                      {t(r.name)}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {requester?.requestType == 3 &&
                <Grid item xs={12} sm={4} lg={4}>
                  <TextField
                    select
                    fullWidth
                    label={t('Eligibility Bypass')}
                    className={classes.roleInput}
                    value={requester.bypass}
                    onChange={(e) => {
                      setRequester({
                        ...requester,
                        bypass: e.target.value,
                      });
                    }}
                  >
                    {[
                      { label: "Skip Eligibility", value: true },
                      { label: "Check Eligibility", value: false },
                    ].map((r, i) => (
                      <MenuItem value={r.value} key={i}>
                        {t(r.label)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              }
              {requester?.requestType == 3 &&
                <Grid item xs={12} sm={4} lg={4}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <KeyboardDatePicker
                      // disableToolbar
                      variant="inline"
                      format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                      margin="normal"
                      label={t("Loyalty Start Date")}
                      id="date-picker-inline2"
                      className={classes.dateInput}
                      value={requester.loyaltyStartDate}
                      maxDate={new Date()}
                      onChange={(date) => {
                        setRequester({ ...requester, loyaltyStartDate: date })
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              }
              {requester?.requestType == 3 && <Grid xs={12} sm={8} lg={8}></Grid>}
              {(parseInt(requester.requestType) === 1 ||
                parseInt(requester.requestType) === 2) && (
                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      fullWidth
                      type="number"
  onWheel={(e) => e.target.blur()}
                      label={t('Shipto')}
                      onKeyDown={blockInvalidChar}
                      autoComplete="off"
                      value={requester.shipto}
                      onChange={(e) => {
                        setRequester({
                          ...requester,
                          shipto: e.target.value,
                        });
                      }}
                    />
                  </Grid>
                )}
              {parseInt(requester.requestType) === 2 && (
                <Grid item xs={12} sm={4} lg={4}>
                  <TextField
                    fullWidth
                    type="text"
                    label={t('Connection Awards Member Id')}
                    autoComplete="off"
                    value={requester.memberId}
                    onChange={(e) => {
                      setRequester({
                        ...requester,
                        memberId: e.target.value,
                      });
                    }}
                  />
                </Grid>
              )}
              {(parseInt(requester.requestType) === 1 ||
                parseInt(requester.requestType) === 2) && (
                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      select
                      fullWidth
                      label={t('Eligibility Bypass')}
                      className={classes.roleInput}
                      value={requester.bypass}
                      onChange={(e) => {
                        setRequester({
                          ...requester,
                          bypass: e.target.value,
                        });
                      }}
                    >
                      {[
                        { label: "Skip Eligibility", value: true },
                        { label: "Check Eligibility", value: false },
                      ].map((r, i) => (
                        <MenuItem value={r.value} key={i}>
                          {t(r.label)}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
              {(parseInt(requester.requestType) === 1 ||
                parseInt(requester.requestType) === 2) &&
                <Grid item xs={12} sm={3} lg={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <KeyboardDatePicker
                      // disableToolbar
                      variant="inline"
                      format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                      margin="normal"
                      label={t("Loyalty Start Date")}
                      id="date-picker-inline2"
                      className={classes.dateInput}
                      value={requester.loyaltyStartDate}
                      maxDate={new Date()}
                      onChange={(date) => {
                        setRequester({ ...requester, loyaltyStartDate: date })
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              }
              {parseInt(requester.requestType) === 3 &&
                concurrentShipto.map((item, index) => {
                  return <Grid container xs={12} spacing={2}>
                    <Grid item xs={12} sm={4} lg={4}>
                      <TextField
                        fullWidth
                        type="number"
  onWheel={(e) => e.target.blur()}
                        label={t('Shipto')}
                        onKeyDown={blockInvalidChar}
                        autoComplete="off"
                        value={item.shipto}
                        onChange={(e) => {
                          let arr = [...concurrentShipto];
                          arr[index].shipto = e.target.value;
                          setConcurrentShipto(arr);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} lg={4}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                        <KeyboardDatePicker
                          // disableToolbar
                          variant="inline"
                          format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                          margin="normal"
                          label={t("Signature Start Date")}
                          id="date-picker-inline2"
                          className={classes.dateInput}
                          value={item.signatureStartDate}
                          minDate={requester.loyaltyStartDate}
                          maxDate={new Date()}
                          error={signatureStartDateErr?.error}
                          helperText={signatureStartDateErr?.text}
                          onChange={(date) => {
                            let arr = [...concurrentShipto];
                            arr[index].signatureStartDate = date;
                            setConcurrentShipto(arr);
                          }}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                          autoOk
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                    {/* <Grid item xs={12} sm={2} lg={2}> 
                    <TextField
                      className={classes.paymentdropenroll}
                      label={t('Payment Plan')}
                      
                                                select
                                                // value={editObj?.is_active}
                                                onChange={(e) => {
                                                  let arr = [...concurrentShipto];
                                                  arr[index].privilegecode = e.target.value;
                                                  setConcurrentShipto(arr);
                                                }}
                                                // style={{ width: "115%" }}
                                >
                                    <MenuItem value="ST0">Monthly</MenuItem>
                                    <MenuItem value="ST1">Yearly</MenuItem>
                                    <MenuItem value="ST2">Trial</MenuItem>
                                </TextField> 
                                </Grid> 
                                <Grid></Grid> */}

                    {/* Payment Plan Dropdown */}
                    <Grid item xs={12} sm={4} lg={4}>
                      <TextField
                        className={classes.paymentdropenroll}
                        label={t('Payment Plan')}
                        select
                        value={item.privilegecode}  // bind to your payment plan state
                        onChange={(e) => {
                          let arr = [...concurrentShipto];
                          arr[index].privilegecode = e.target.value;
                          setConcurrentShipto(arr);
                        }}
                      >
                        <MenuItem value="ST0">Monthly</MenuItem>
                        <MenuItem value="ST1">Yearly</MenuItem>
                        <MenuItem value="ST2">Trial</MenuItem>
                      </TextField>
                    </Grid>

                    {item.privilegecode === "ST2" && (  // Check if the payment plan is "Trial"
                      <Grid item xs={12} sm={4} lg={4}>
                        <TextField
                          select
                          fullWidth
                          label={t('Trial Period')}
                          value={item.trialPeriod}
                          className={classes.paymentdropenroll}
                          onChange={(e) => {
                            let arr = [...concurrentShipto];
                            arr[index].trialPeriod = e.target.value;
                            setConcurrentShipto(arr);
                          }}
                        >
                          <MenuItem value={3}>3 Months</MenuItem>
                          <MenuItem value={4}>4 Months</MenuItem>
                          <MenuItem value={5}>5 Months</MenuItem>
                          <MenuItem value={6}>6 Months</MenuItem>
                        </TextField>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={1} lg={1}>
                      {concurrentShipto.length - 1 == index && <ControlPointIcon
                        style={{
                          color: "green",
                          cursor: "pointer",
                          position: "relative",
                          top: 30,
                          left: 125
                        }}
                        onClick={() => {
                          if (concurrentShipto[concurrentShipto.length - 1].shipto.length == 0) return toast.error('Please type the shipto', { toastId: '1' })
                          setConcurrentShipto([...concurrentShipto, {
                            shipto: '',
                            loyaltyStartDate: new Date(),
                            isSignature: false,
                            signatureStartDate: new Date()

                          }]);
                        }}
                      />}
                      {concurrentShipto.length - 1 != index && <DeleteIcon
                        style={{
                          color: "red",
                          cursor: "pointer",
                          position: "relative",
                          top: 30,
                          left: 125
                        }}
                        onClick={() => {
                          let arr = [...concurrentShipto];
                          arr.splice(index, 1);
                          setConcurrentShipto(arr);
                        }}
                      />}
                    </Grid>
                  </Grid>
                })}
            </React.Fragment>
            <Grid item xs={12} className={classes.submitBtnGrid}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={classes.btn}
                onClick={() => {
                  if (state?.userInfo?.editAction) {
                    if (!requester?.requestType) {
                      toast.error("Fill all the fields", {
                        toastId: "fields-empty",
                      });
                      return;
                    }
                    if (parseInt(requester?.requestType) === 1) {
                      if (!requester?.shipto) {
                        toast.error("Fill all the fields", {
                          toastId: "fields-empty",
                        });
                        return;
                      }
                    }
                    // Validate for trial period
                    if (parseInt(requester?.requestType) === 3) {
                      for (const item of concurrentShipto) {
                        if (item.privilegecode === 'ST2') {
                          const selectedStartDate = moment(item.signatureStartDate);
                          const periodMonths = parseInt(item.trialPeriod);
                          console.log(periodMonths, "periodMonths", item.trialPeriod)
                          if (!periodMonths) {
                            toast.error("Please select the Trial Period for trial customers.");
                            return;
                          }

                          const trialEndDate = selectedStartDate.clone().add(periodMonths, 'months');
                          const today = moment();

                          // Ensure the trial hasn’t already expired
                          if (trialEndDate.isBefore(today, 'day')) {
                            toast.error(
                              `The selected start date is not allowed because the trial would have already ended. Please select a signature start date that allows the full ${periodMonths}-month trial.`
                            );
                            return;
                          }

                          // Optional: prevent selecting dates too old
                          const maxBackDate = today.clone().subtract(periodMonths, 'months');
                          if (selectedStartDate.isBefore(maxBackDate, 'day')) {
                            toast.error(
                              `The trial start date can be at most ${periodMonths} months before today.`
                            );
                            return;
                          }
                        }
                      }
                    }

                    if (parseInt(requester?.requestType) === 3) {
                      if (!concurrentShipto?.length || concurrentShipto.some(item => !item.privilegecode)) {
                        toast.error("Please Select the Payment Plan", { toastId: "fields-empty" });
                        return;
                      }
                    }

                    if (parseInt(requester?.requestType) === 2) {
                      if (!requester?.shipto || !requester?.memberId) {
                        toast.error("Fill all the fields", {
                          toastId: "fields-empty",
                        });
                        return;
                      } else if (isNaN(parseInt(requester?.memberId))) {
                        toast.error("Invalid Member Id", {
                          toastId: "invalid-memberId",
                        });
                        return;
                      }
                    }
                    handleCreateUsers();
                    return;
                  }
                  else {
                    toast.error(state.userInfo?.editAccess)
                    return;
                  }
                }}
              // disabled={!access['editAccess'][state.userInfo?.role]['create-users']}
              >
                {t('Create')}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </div>
      <Dialog
        open={modal}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={classes.dialogContent}>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.disalogContentText}
          >
            {t('User created successfully')}
          </DialogContentText>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.dialogText}
          >
            <span className={classes.dialogTextHead}>{t('Shipto Id')}</span> :{" "}
            {modalData?.customerId}
          </DialogContentText>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.dialogText}
          >
            <span className={classes.dialogTextHead}>{t('Billto Id')}</span> :{" "}
            {modalData?.billingId}
          </DialogContentText>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.dialogText}
          >
            <span className={classes.dialogTextHead}>{t('Loyalty Id')}</span> :{" "}
            {modalData?.loyaltyId}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.closeBtn}
            onClick={() => {
              setModal(false);
            }}
          >
            {t('Close')}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
